export default __webpack_public_path__ + "static/media/receivePatient.911373f2.png";